import { http, type HttpClient } from './core/http-client';
import type { AuthenticatorAppSetup, MfaStatus, SessionUser } from './models';

const opts = { query: { audience: 'business' } };

// Two-step verification for the signed-in person (/auth/mfa/*).
export class MfaService {
  constructor(private readonly http: HttpClient) {}

  status = () => this.http.get<MfaStatus>('/auth/mfa/status', opts);

  startSetup = () =>
    this.http.post<AuthenticatorAppSetup>('/auth/mfa/authenticator-app/setup', {}, opts);

  confirmSetup = (code: string) =>
    this.http.post<{ recoveryCodes: string[] }>(
      '/auth/mfa/authenticator-app/confirm',
      { code },
      opts,
    );

  // A code for the current sign-in, e.g. to open the admin area.
  verify = (code: string) => this.http.post('/auth/mfa/verify', { code }, opts);

  newRecoveryCodes = (code: string) =>
    this.http.post<{ recoveryCodes: string[] }>('/auth/mfa/recovery-codes', { code }, opts);

  disable = (code: string) => this.http.post('/auth/mfa/disable', { code }, opts);

  // Second step of sign-in, after the password step asked for a code.
  completeLogin = (challenge: string, code: string) =>
    this.http.post<{ user: SessionUser }>('/auth/mfa/login', { challenge, code }, opts);
}

export const mfaService = new MfaService(http);
